import React, { useEffect, useState } from 'react';
import classes from './EditableLabel.module.scss';
import colors from '../../../../scss/colors';
import PropTypes from 'prop-types';

export default function EditableLable(props) {
  const {
    value,
    changeHandler,
    fontSize = '14px',
    fontWeight = '400',
    fontColor = colors.NAVY_BLUE,
    type = 'number',
    disabled = false,
    width = '100%',
    enableKeyUp = false,
    sx,
    rootSx,
    placeholder = '',
    label = ''
  } = props;

  const [tempValue, setTempValue] = useState(value);

  const onBlurHandler = () => {
    if (tempValue !== value) {
      changeHandler(tempValue);
    }

    if (!tempValue) {
      setTempValue(0);
    }
  };

  const onFocusHandler = () => {
    if (Number(tempValue) === 0) {
      setTempValue('');
    }
  };

  const onKeyHandler = (e) => {
    if (enableKeyUp) {
      setTempValue(e.target.value);
      changeHandler(e.target.value);
    }
  };

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  return (
    <div className={classes.fieldWrapper} style={rootSx}>
      {label && ( <label for={label}>{label}</label> )}
      <input
        id={label}
        aria-label={placeholder || 'input'}
        aria-labelledby={(placeholder || 'input') + 'Label'}
        disabled={disabled}
        className={`${classes.field} ${disabled ? classes.disabled : ''}`}
        style={{ fontSize, color: Number(tempValue) === 0 ? colors.MEDIUM_GREY_V2 : fontColor, fontWeight, width, ...sx }}
        type={type}
        title={placeholder || 'editableLabel'}
        placeholder={placeholder}
        value={tempValue || ''}
        onChange={(e) => {
          setTempValue(e.target.value);
        }}
        onBlur={onBlurHandler}
        onFocus={onFocusHandler}
        onKeyUp={(e) => onKeyHandler(e)}
      />
    </div>
  );
}

EditableLable.propTypes = {
  value: PropTypes.any,
  changeHandler: PropTypes.func,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  fontColor: PropTypes.string,
  type: PropTypes.oneOf(['number', 'text']),
  disabled: PropTypes.bool
};
